import { SpecsObject } from "@/__generated__/graphql";
import React from "react";
import { useMutation } from "@apollo/client";
import { Button } from "@/components/ui/button";
import SaveIcon from "@/assets/save.svg";
import {
  SaveDefaultSpecsMutation,
  SaveDefaultSpecsMutationVariables,
} from "@/__generated__/graphql";
import { SAVE_DEFAULT_SPECS_MUTATION } from "./DefaultSpecsMutation";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface DefaultSpecsProps {
  serviceId: string;
  projectId: string;
  specsList: SpecsObject[];
}

export const DefaultSpecs: React.FC<DefaultSpecsProps> = ({
  serviceId,
  projectId,
  specsList,
}) => {
  const [manageNotification] = useMutation<
    SaveDefaultSpecsMutation,
    SaveDefaultSpecsMutationVariables
  >(SAVE_DEFAULT_SPECS_MUTATION);

  if (!specsList) return;

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className="border border-accent-foreground p-2 h-full !hover:bg-accent !cursor-pointer"
            onClick={async () => {
              manageNotification({
                variables: {
                  serviceId,
                  projectId,
                  specList: specsList.filter(
                    (spec) => !!Object.keys(spec).length,
                  ),
                },
              });
            }}
            disabled={
              !specsList?.filter((data) => data.formatId && data.specId).length
            }
          >
            <img src={SaveIcon} alt="" className="invert dark:invert-0" />
          </Button>
        </TooltipTrigger>

        <TooltipContent>
          Click to save this as the default delivery specifications for this
          service.
        </TooltipContent>
      </Tooltip>
    </>
  );
};
